import { toDate } from 'utils/converters';

const formatCooperativa = (dados) => {
  const { dados: dado, escolherLotes } = dados;

  return {
    ...dado,
    cooperativa: dado.cooperativa.id,
    entries: escolherLotes.map((lote) => ({
      id: lote.idLote,
      type: lote.loteTipo,
    })),
    kg: parseFloat(dado.kg),
    date: toDate(dado.date),
  };
};

export { formatCooperativa };
